export default function Footer() {
  return (
    <footer className="container">
      <div className="footer">
        <div>
          <span className="seal">“Bring back what is lost.”</span>
        </div>
        <div className="tiny">© {new Date().getFullYear()} ezbounty</div>
      </div>
    </footer>
  );
}
